<template>
    <v-dialog v-model="mostrar" persistent max-width="50vw" scrollable >
			<v-card :loading="loading" max-height="600px" >
				<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
				<v-divider></v-divider>
				<v-card-text>
				<v-container>
					<v-row>
						<v-col cols="12">
							<v-text-field :append-icon="mostrar1 ? 'mdi-eye' : 'mdi-eye-off'"
											:type="mostrar1 ? 'text' : 'password'"
											@click:append="mostrar1 = !mostrar1"
											label="Senha atual" 
											v-model="senhas.senhaAtual" 
											outlined
											>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field :append-icon="mostrar2 ? 'mdi-eye' : 'mdi-eye-off'"
											:type="mostrar2 ? 'text' : 'password'"
											@click:append="mostrar2 = !mostrar2"
											label="Nova senha" 
											v-model="senhas.novaSenha" 
											outlined
										>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field :append-icon="mostrar3 ? 'mdi-eye' : 'mdi-eye-off'"
											:type="mostrar3 ? 'text' : 'password'"
											@click:append="mostrar3 = !mostrar3"
											label="Confirme a senha" 
											v-model="senhas.senhaConfirmada" 
											outlined
											>
							</v-text-field>
						</v-col>
					</v-row>
				</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click.stop="confirmar()">Salvar</v-btn>
					<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'

export default {
    props:['mostrar'],
    computed:{...mapState(['user'])},
    data(){
        return{
            senhas: {},
            cor: "primary",
            mostrar1: false,
            mostrar2: false,
            mostrar3: false,
            loading: false,
        }
    },
    methods:{
        fechar(){
            this.$emit('fecharAlterarSenha')
        },

        confirmar(){
                this.senhas.idUser = this.user.user
				this.loading = true
				if(this.senhas.novaSenha === this.senhas.senhaConfirmada && this.senhas.novaSenha){
					
					const url = `${baseApiUrl}/preferencias/alterarSenha.php` 
					
					axios.post(url, this.senhas)
					.then(res => {
						
						if(res.data.codigo == '01'){
							showSuccess(res.data.mensagem)
							this.fechar()
						}else{
							showError(res.data.mensagem)
						}
						
						
					})
					.catch({showError})

				}else{
					if(this.senhas.novaSenha){
						showError('Nova senha não confere.')	
					}else{
						showError('Senha deve ser preenchida')
					}
					
				}

				this.loading = false
			},
    },

    watch:{
        mostrar(val){
            if(val){
                this.senhas = {}
            }
        }
    }
}
</script>

<style scoped>
</style>